import axios from 'axios';
import {
  LOGIN_USER,
  REGISTER_USER,
  CONFIRM_USER,
  AUTH_USER,
  IS_USER_AUTH,
  LOGOUT_USER,
  IMAGE_UPLOAD,
  USER_TOKEN,
} from './types';

import { SERVER_URL, USER_SERVER } from '../components/Config.js';

// import { Amplify, Storage } from 'aws-amplify';
import {
  signInWithRedirect,
  fetchAuthSession,
  signOut,
  decodeJWT,
} from 'aws-amplify/auth';

// import awsExports from './aws-config';

// Amplify.configure(awsExports);

// export function registerUser(dataToSubmit) {
//   const request = Auth.signUp({
//     username: dataToSubmit.email,
//     password: dataToSubmit.password,
//     attributes: {
//       email: dataToSubmit.email,
//       name: dataToSubmit.name,
//       family_name: dataToSubmit.lastname,
//     },
//   }).then((user) => {
//     axios.post(`${SERVER_URL}${USER_SERVER}/register`, dataToSubmit);

//     return {
//       success: true,
//     };
//   });

//   return {
//     type: REGISTER_USER,
//     payload: request,
//   };
// }

// export function confirmNewUser(dataToSubmit) {
//   const request = Auth.confirmSignUp(
//     dataToSubmit.email,
//     dataToSubmit.code
//   ).then((res) => {
//     return {
//       success: true,
//     };
//   });

//   return {
//     type: CONFIRM_USER,
//     payload: request,
//   };
// }

// export function loginUser(dataToSubmit) {
//   const request = Auth.signIn({
//     username: dataToSubmit.email,
//     password: dataToSubmit.password,
//   }).then((user) => {
//     return {
//       loginSuccess: true,
//       userId: user.username,
//     };
//   });

//   return {
//     type: LOGIN_USER,
//     payload: request,
//   };
// }

export function auth() {
  const request = getAuthorizationHeader().then((config) => {
    return axios
      .get(`${SERVER_URL}${USER_SERVER}/auth`, config)
      .then((response) => {
        return response.data;
      });
  });

  return {
    type: AUTH_USER,
    payload: request,
  };
}

export async function isUserAuth() {
  const request = await fetchAuthSession()
    .then((res) => {
      return true;
    })
    .catch((err) => {
      console.log(err);
    });

  return {
    type: IS_USER_AUTH,
    payload: request,
  };
}

export async function userToken() {
  const request = await fetchAuthSession();
  // .then((res) => {
  //   console.log('🚀 ~ userToken ~ res:', res.tokens?.idToken?.payload);
  //   return res.tokens?.idToken?.payload.toString();
  // })
  // .catch((err) => {
  //   console.log(err);
  // });

  return request.tokens?.idToken.toString();
}

export function logoutUser() {
  const request = signOut().then(() => {
    return {
      success: true,
    };
  });
  return {
    type: LOGOUT_USER,
    payload: request,
  };
}

// export function uploadImage(file) {
//   const fileName = `uploads/${file.name}`;

//   const request = Storage.put(fileName, file).then((result) => {
//     return {
//       image: fileName,
//       success: true,
//     };
//   });

//   return {
//     type: IMAGE_UPLOAD,
//     payload: request,
//   };
// }

function getAuthorizationHeader() {
  return fetchAuthSession().then((res) => {
    const token = res.getAccessToken();
    const jwtToken = token.getJwtToken();

    const config = {
      headers: { Authorization: `Bearer ${jwtToken}` },
    };

    return config;
  });
}

export async function decodeCurrentToken() {
  const session = await fetchAuthSession();
  console.log('🚀 ~ SignInRedirect ~ session:', session);
  const token = session.tokens?.idToken?.toString();
  const decodedToken = decodeJWT(token.toString()).payload;
  return decodedToken;
}
